import { Input } from '@mantine/core';
import { useIntl } from 'react-intl';

import PhoneNumberInput from 'Components/Common/PhoneNumber/PhoneNumberInput';
import styles from 'Screens/Dashboard/AllEntities/Details/Inputs/EntityInputs.module.scss';
import sharedMessages from 'Components/utils/sharedMessages';
import { useEntityContext } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';

const EntityPhoneNumberInput = () => {
    const intl = useIntl();
    const { state, dispatch } = useEntityContext();
    const {
        phoneNumber,
    } = state;

    const onChange = (value: string) => {
        dispatch({ type: 'UPDATE_ENTITY_PHONE_NUMBER', payload: value });
    };

    return (
        <Input.Wrapper
            className={styles.textInput}
            label={intl.formatMessage(sharedMessages.phoneNumber)}
            labelProps={{ htmlFor: 'phone-number' }}
        >
            <PhoneNumberInput
                id="phone-number"
                value={phoneNumber}
                onChange={onChange}
            />
        </Input.Wrapper>
    );
};

export default EntityPhoneNumberInput;
